import React from 'react';
import { Outlet } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { MarketTopicList } from './MarketTopicList';

/** Contenedor de la sección Vanguard Market: índice lateral en escritorio y desplegable en móvil. */
export function MarketShell() {
  return <main className="market-doc w-full bg-[#050b14] pt-20 pb-20 md:pt-28" data-id="element-1056" data-mp="1xb95kmbzo4yd">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 lg:grid-cols-[240px_minmax(0,1fr)] lg:px-8" data-id="element-1057" data-mp="1x96gq5mkohv8">
        <aside className="hidden lg:block print:hidden" data-id="element-1058" data-mp="15kcqrg6dbq8g">
          <div className="sticky top-28 max-h-[calc(100vh-8rem)] overflow-y-auto pb-6" data-id="element-1059" data-mp="15kuwd3ex7gt1">
            <MarketTopicList data-id="element-1060" data-mp="19l516cqz816b" />
          </div>
        </aside>
        <div className="min-w-0" data-id="element-1061" data-mp="1ecepna0sgygm">
          <details className="group mb-6 rounded-2xl border border-white/10 lg:hidden print:hidden" data-id="element-1062" data-mp="1edonpz7n66n9">
            <summary className="flex cursor-pointer list-none items-center justify-between px-4 py-3 text-sm font-semibold text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] [&::-webkit-details-marker]:hidden" data-id="element-1063" data-mp="htz8ghdl55r2">
              Temas del Vanguard Market
              <ChevronDown className="h-4 w-4 transition-transform duration-200 group-open:rotate-180" aria-hidden="true" data-id="element-1064" data-mp="21978dha0n5o9" />
            </summary>
            <div className="px-1 pb-3" data-id="element-1065" data-mp="1wfcq8ia26yra">
              <MarketTopicList data-id="element-1066" data-mp="1riunfnyahahl" />
            </div>
          </details>
          <Outlet data-id="element-1067" data-mp="1rgi7fgc3da76" />
        </div>
      </div>
    </main>;
}

/** Abre las explicaciones plegadas antes de imprimir para no perder contenido. */
export function printWithDetails() {
  document.querySelectorAll<HTMLDetailsElement>('.market-doc details').forEach(d => {
    if (!d.closest('.print\\:hidden')) d.open = true;
  });
  window.print();
}